import React from "react";

import { useLocation, useNavigate } from "react-router-dom";

import { Box, Typography, Button, SvgIcon, Stack } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import KeyboardDoubleArrowUpIcon from "@mui/icons-material/KeyboardDoubleArrowUp";

import Logo from "../../shared/Logo/Logo";
import HeaderBarcode from "../../shared/HeaderBarcode/HeaderBarcode";
import FooterBarcode from "../../shared/FooterBarcode/FooterBarcode";
import BackToMapButton from "../../UI/BackToMapButton/BackToMapButton";
import completionBadge from "../../../assets/images/icon-completion-badge.png";

import { ReactComponent as successRookie } from "../../../assets/images/rookie-success.svg";
import { ReactComponent as successAdvanced } from "../../../assets/images/advanced-success.svg";
import { ReactComponent as successIntermediate } from "../../../assets/images/intermediate-success.svg";

import "./MissionComplete.scss";

const MissionComplete = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [nextLevel, setNextLevel] = React.useState("");
  const [description, setDescription] = React.useState("");
  const [missionTitle, setMissionTitle] = React.useState("");
  const [missionNumber, setMissionNumber] = React.useState("");
  const [missionDebrief, setMissionDebrief] = React.useState("");
  const [selectedLevel, setSelectedLevel] = React.useState("");
  // Check if stageClearData is available in location state
  React.useEffect(() => {
    if (!location.state?.stageClearData) {
      // If not, navigate back to the previous page
      navigate(-1);
    } else {
      const {
        nextLevel,
        description,
        missionTitle,
        missionNumber,
        missionDebrief,
        selectedLevel,
      } = location.state.stageClearData || {};
      // Set the state variables with the data from location state
      setNextLevel(nextLevel);
      setDescription(description);
      setMissionTitle(missionTitle);
      setMissionNumber(missionNumber);
      setSelectedLevel(selectedLevel);
      setMissionDebrief(missionDebrief);
    }
  }, [location.state, navigate]);
  // Extract data from state (default to empty if not provided)

  const handleReplay = () => {
    navigate(-1);
  };
  const handleLevelUp = () => {
    navigate(`${nextLevel}`, { state: { selectedLevel } });
  };

  const getCoinSrc = (level) => {
    switch (level) {
      case "Rookie":
        return successRookie;
      case "Intermediate":
        return successIntermediate;
      case "Advanced":
        return successAdvanced;
      default:
        return successRookie;
    }
  };

  return (
    <Stack className={`mission-complete-container mission-${missionNumber}`}>
      <Stack className="dotted-background">
        <Stack direction={"column"} className="container header">
          <HeaderBarcode />
          {missionTitle !== "Advanced" && <BackToMapButton />}
        </Stack>
        <Stack
          className="container content"
          justifyContent={"center"}
          alignItems={"center"}
        >
          <Box className="notice-board">
            <Stack useFlexGap gap={4}>
              <Stack useFlexGap gap={3} className="wrapper">
                <Stack className="coin-section" alignItems={"center"}>
                  <SvgIcon
                    component={getCoinSrc(missionTitle)}
                    className="coin-image"
                    inheritViewBox
                  />
                </Stack>

                <Typography variant="h4" className="mission-title">
                  {`Mission ${missionNumber} - ${missionTitle}` ||
                    `Mission Completed`}
                </Typography>
                <Typography variant="h4" className="mission-status">
                  SUCCESS!
                </Typography>
                <Typography className="mission-subtitle">
                  {missionDebrief}
                </Typography>
              </Stack>
              <div>
                <Typography className="mission-subtitle">
                  {missionTitle !== "Advanced" && (
                    <>
                      <img
                        src={completionBadge}
                        alt="Mission Completed"
                        className="completion-image"
                      />
                      Congratulations! You've earned{" "}
                      <span>{missionTitle || "a"}</span> coin.
                    </>
                  )}
                </Typography>

                <Typography className="mission-description">
                  {missionTitle !== "Advanced" && <strong>Aim higher:</strong>}
                  <span>{description || "Keep going for more rewards!"}</span>
                </Typography>
              </div>
              {missionTitle !== "Advanced" ? (
                <Stack
                  direction="row"
                  spacing={2}
                  justifyContent="center"
                  className="action-buttons"
                >
                  <Button
                    variant="contained"
                    className="btn level-up-button"
                    onClick={handleLevelUp}
                  >
                    <SvgIcon
                      component={KeyboardDoubleArrowUpIcon}
                      inheritViewBox
                    />
                    Level-up
                  </Button>
                  <Button
                    variant="contained"
                    className="btn replay-button"
                    startIcon={<RefreshIcon />}
                    onClick={handleReplay}
                  >
                    Replay
                  </Button>
                </Stack>
              ) : (
                <Stack
                  direction="row"
                  spacing={2}
                  justifyContent="center"
                  className="action-buttons"
                >
                  <Button
                    variant="contained"
                    className="btn level-up-button"
                    onClick={() => navigate("/map")}
                  >
                    <SvgIcon component={ArrowBackIcon} inheritViewBox />
                    Back to map
                  </Button>
                  <Button
                    variant="contained"
                    className="btn replay-button"
                    startIcon={<RefreshIcon />}
                    onClick={handleReplay}
                  >
                    Replay
                  </Button>
                </Stack>
              )}
            </Stack>
          </Box>
        </Stack>
        <Stack className="container footer">
          <Logo />
          <FooterBarcode />
        </Stack>
      </Stack>
    </Stack>
  );
};

export default MissionComplete;
